import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Skeleton from "@material-ui/lab/Skeleton";
import boxShadows from "assets/theme/box-shadow";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const useCardStyles = makeStyles({
  cardRoot: {
    marginBottom: "1rem",
  },
  cardContentRoot: {
    padding: "1rem 1.5rem !important",
  },
  textUppercase: {
    textTransform: "uppercase",
  },
  bgIcon: {
    backgroundColor: themeColorsDesingSystem.primary.main,
  },
});

const BignumberIcon = ({ color, boxShadow, iconClass, icon }) => {
  return (
    <Grid
      item
      xs={3}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        width="3rem"
        height="3rem"
        padding="12px"
        textAlign="center"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        borderRadius="50%"
        boxShadow={boxShadow}
        color={color}
        className={iconClass}
      >
        {icon && typeof icon === "object" ? (
          <Box
            component={icon}
            width="1.5rem!important"
            height="1.5rem!important"
          />
        ) : null}
        {icon && typeof icon === "string" ? (
          <Box component="i" fontSize="1.25rem" className={icon} />
        ) : null}
      </Box>
    </Grid>
  );
};

export default function Bignumber({
  value,
  label,
  icon,
  onClickLabel,
  iconPosition,
  logScreen,
}) {
  const classes = useCardStyles();

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          {iconPosition === "left" && (
            <BignumberIcon
              icon={icon}
              boxShadow={boxShadows.boxShadow}
              color={themeColorsDesingSystem.background.main}
              iconClass={classes.bgIcon}
            />
          )}
          <Grid item xs={9} style={{ paddingRight: 0 }}>
            <Box
              component={Typography}
              variant="h5"
              marginBottom="0!important"
              marginTop="0!important"
              className={classes.textUppercase}
              color={themeColorsDesingSystem.gray.main}
              style={
                logScreen
                  ? {
                      fontSize: "1.25rem",
                      cursor: onClickLabel ? "pointer" : "initial",
                      textDecoration: onClickLabel ? "underline" : "none",
                    }
                  : {
                      cursor: onClickLabel ? "pointer" : "initial",
                      textDecoration: onClickLabel ? "underline" : "none",
                    }
              }
              onClick={onClickLabel || null}
            >
              {label}
            </Box>
            <Box
              component={Typography}
              variant="h2"
              fontWeight="600!important"
              marginBottom="0!important"
              marginTop="0!important"
              style={logScreen ? { fontSize: "1.75rem" } : {}}
            >
              {value !== null || value !== undefined || value !== "" ? (
                value
              ) : (
                <Skeleton />
              )}
            </Box>
          </Grid>
          {iconPosition !== "left" && (
            <BignumberIcon
              icon={icon}
              boxShadow={boxShadows.boxShadow}
              color={themeColorsDesingSystem.background.main}
              iconClass={classes.bgIcon}
            />
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}
